/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { getEnumTitle, PropertyFeatures } from '@zcode/enums'

export const mapFeatures = (features: readonly PropertyFeatures[]) => {
  return features.map((featureId) => {
    return getEnumTitle(PropertyFeatures, featureId)
  })
}
